const CHECK_ADEBIFY_FEATURE = 'adebify/CHECK_ADEBIFY_FEATURE';
const SET_ADEBIFY_ENABLED = 'adebify/SET_ADEBIFY_ENABLED';
const SET_ADEBIFY_LOADING = 'adebify/SET_ADEBIFY_LOADING';

export default {
  CHECK_ADEBIFY_FEATURE,
  SET_ADEBIFY_ENABLED,
  SET_ADEBIFY_LOADING,
};
